module.exports = __webpack_public_path__ + "static/media/bj.91931f25.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bj.svg
// module id = 2049
// module chunks = 0